import React from "react";

import { AcceptButton } from "../../../components/ui/button/v2/AcceptButton";
import { RejectButton } from "../../../components/ui/button/v2/RejectButton";
import { CrossButton } from "../../../components/ui/button/v2/CrossButton";
import { cn } from "../../../lib/utils";
import ButtonV2 from "../../../components/ui/button/v2";

export type StageWorkflowDecisionModalVariant = "accept" | "reject";

export interface StageWorkflowDecisionModalProps {
  isOpen: boolean;
  variant: StageWorkflowDecisionModalVariant;
  title: string;
  subtitle: string;

  primaryButtonLabel: string;
  onPrimaryAction: () => void;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;

  onClose: () => void;
  className?: string;
}

const StageWorkflowDecisionModal: React.FC<StageWorkflowDecisionModalProps> = ({
  isOpen,
  variant,
  title,
  subtitle,
  primaryButtonLabel,
  onPrimaryAction,
  primaryDisabled = false,
  primaryLoading=false,
  onClose,
  className,
}) => {
  const renderTitleAndSubtitle = () => (
    <div className="flex flex-col items-center text-center">
      <div className="font-sans text-lg font-semibold leading-[100%] tracking-normal text-[#0A0A0A] mb-1.5">
        {title}
      </div>
      <div className="font-sans text-sm font-normal leading-5 tracking-normal text-[#737373] mb-4">
        {subtitle}
      </div>
    </div>
  );

const renderCancelButton = () => (
    <ButtonV2
      variant="outline"
      size="md"
      onClick={onClose}
      disabled={primaryLoading}
      className={cn(
        "h-9 w-[184.5px] border border-[#E5E5E5] bg-white px-4 py-2 hover:bg-gray-50",
        "font-sans text-sm font-medium leading-5 text-[#0A0A0A]",
      )}
    >
      Cancel
    </ButtonV2>
  );

  const renderAcceptButton = () => (
    <AcceptButton
      label={primaryButtonLabel}
      onClick={onPrimaryAction}
      disabled={primaryDisabled}
      loading={primaryLoading}
      className="w-[184.5px]"
    />
  );

  const renderRejectButton = () => (
    <RejectButton
      label={primaryButtonLabel}
      onClick={onPrimaryAction}
      disabled={primaryDisabled}
      loading={primaryLoading}
      className="w-[184.5px]"
    />
  );

  const renderButtons = () => (
    <div className="flex items-center gap-2">
      {renderCancelButton()}
      {variant === "accept" ? renderAcceptButton() : renderRejectButton()}
    </div>
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[rgba(10,10,10,0.20)] flex items-center justify-center z-[9999]">
      <div
        className={cn(
          "relative bg-white border border-[#E5E5E5] rounded-lg shadow-lg p-6",
          "w-full max-w-[425px]",
          className,
        )}
        style={{ gap: "16px" }}
      >
        <CrossButton onClick={onClose} disabled={primaryLoading} />
        {renderTitleAndSubtitle()}
        {renderButtons()}
      </div>
    </div>
  );
};

export default StageWorkflowDecisionModal;